import React, { useEffect, useState } from 'react';
import { Fade } from '@mui/material';
import * as S from './CircularProgressbar.styles';
const CircularProgressbar = ({
  value = 0,
  label,
  compact = false
}) => {
  const [counter, setCounter] = useState(0);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (value !== 0) {
      setProgress(value);
    }
  }, [value]);
  useEffect(() => {
    if (progress === 0) return;
    const timer = setInterval(() => {
      setCounter(prev => {
        if (prev === progress) {
          clearInterval(timer);
        }
        return prev === progress ? prev : prev + 1;
      });
    }, 10);
    return () => {
      clearInterval(timer);
    };
  }, [progress]);
  const size = compact ? 88 : 112;
  const coordinates = size / 2;
  const strokeWidth = coordinates * 0.2;
  const radius = coordinates - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  return /*#__PURE__*/React.createElement(S.Root, {
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement(S.Progress, {
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement(S.CircleBack, {
    r: radius,
    cx: coordinates,
    cy: coordinates,
    strokeWidth: strokeWidth,
    sx: {
      strokeDasharray: circumference,
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement(S.CircleFront, {
    r: radius,
    cx: coordinates,
    cy: coordinates,
    strokeWidth: strokeWidth,
    sx: {
      strokeDasharray: circumference,
      strokeDashoffset: circumference - circumference * (progress / 100)
    }
  })), /*#__PURE__*/React.createElement(S.Frame, {
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 1000
  }, /*#__PURE__*/React.createElement(S.Value, {
    compact: compact
  }, counter, "%")), /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 2000
  }, /*#__PURE__*/React.createElement(S.Label, null, label))));
};
export default CircularProgressbar;